module.exports = __webpack_public_path__ + "1_0_59/img/Kalon.dc6ffb2d.jpg";